import { useSelector } from "react-redux";
import { ArchiveList, ArchiveSearch, ProgramDetailCard, ProgramViewHeader, PromotionRow, ReportModal, ShareModal } from "src/components";
import { ProgramAvailablity, ProgramType } from "src/enums";
import { ProgramDetail } from "src/store";

export const ArchiveView: React.FC = () => {

    const programInfo: ProgramDetail = useSelector((state: any) => state.ProgramViewState);
    return (
        <div className="program-page app-theme2 pb-3">
            <ProgramViewHeader programType={ProgramType.ArchiveVideo} />
            <ProgramDetailCard />
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-8 col-md-12 offset-lg-2 p-0 mb-5">
                        <div className="component-archive">
                            {
                                programInfo.promotion &&
                                <div className="archive-list-area archive-promotions-area container p-sm-0 mb-3">
                                    <div className="col-12 p-0">
                                        <PromotionRow date={""} index={0} {...programInfo.promotion} />
                                    </div>
                                </div>
                            }
                            <ArchiveSearch />
                            <ArchiveList />
                        </div>
                    </div>
                </div>
            </div>
            <ShareModal title={programInfo.info?.title} />
            {!programInfo.loading && programInfo.availability !== ProgramAvailablity.NotFound && <ReportModal />}
        </div>
    );

};